import React from 'react';
import PropTypes from 'prop-types';

import {connect} from '@stubhub/react-store-provider';

import controller from './controller';

import './index.scss';

@connect(controller)
class Profile extends React.Component {
  static propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  };

  render() {
    /* istanbul ignore next */
    const {firstName = '', lastName = ''} = this.props;
    /* istanbul ignore next */
    const abbrName = (firstName[0] || '') + (lastName[0] || '');

    return (
      <div className="Profile">
        <div className="Profile_avatar">{abbrName}</div>
        <div className="Profile_name">
          <span className="Profile_firstName">{firstName}</span>
          <span className="Profile_lastName">{lastName}</span>
        </div>
      </div>
    );
  }
}

export default Profile;
